import {blue, grey} from "@material-ui/core/colors";
import React, {FC} from "react";

type Props = {
  className?: string;
  color: "grey" | "blue";
};

const FfairLogoIcon: FC<Props> = ({className, color}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.31741 10.0266C0.227531 11.1165 0.227531 12.8835 1.31741 13.9734L10.5266 23.1826C11.6165 24.2725 13.3835 24.2725 14.4734 23.1826L23.6826 13.9734C24.7725 12.8835 24.7725 11.1165 23.6826 10.0266L14.4734 0.817363C13.3835 -0.272454 11.6165 -0.272454 10.5266 0.817363L1.31741 10.0266ZM17.4843 9.73361L12.5 4.74931L7.51569 9.73361C6.78912 10.4602 6.78912 11.6382 7.51569 12.3649C8.24227 13.0914 9.42029 13.0914 10.1469 12.3649L11.02 11.4917C11.8373 10.6743 13.1626 10.6743 13.98 11.4917L14.8531 12.3649C15.5797 13.0914 16.7577 13.0914 17.4843 12.3649C18.2109 11.6382 18.2109 10.4602 17.4843 9.73361Z"
        fill={color === "grey" ? grey[400] : blue.A400}
      />
    </svg>
  );
};

export default FfairLogoIcon;
